// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-count-down {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  z-index: 2;
  color: var(--motes-white);
  pointer-events: initial;
}
.quiz-count-down .get-ready {
  position: absolute;
  font-size: 30px;
  text-align: center;
  display: block;
  top: 20vh;
  width: 100%;
}
.quiz-count-down .counter {
  font-size: 150px;
  display: flex;
  opacity: 1;
  width: 100%;
  position: relative;
}
.quiz-count-down .count-label {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
  opacity: 0;
  transform: translateY(-50%) scale(0.1);
}
.quiz-count-down .last-counter {
  font-size: 1.2em;
}
.quiz-count-down .show-counter {
  animation: counter-zoom 700ms;
}
@keyframes counter-zoom {
  30% {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
  80% {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateY(-50%) scale(0.1);
  }
}
.quiz-count-down .background {
  width: 100vw;
  height: 100vw;
  min-width: 100vh;
  min-height: 100vh;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(32, 32, 32, 0.801);
  transform: scale(0.01);
}
@keyframes background-zoom {
  0% {
    transform: scale(0.01);
    border-radius: 50%;
  }
  100% {
    transform: scale(1);
    border-radius: 0;
  }
}
@keyframes background-zoom-out {
  0% {
    transform: scale(1);
    border-radius: 0;
  }
  100% {
    transform: scale(0);
    border-radius: 50%;
  }
}
.quiz-count-down .open-background {
  animation: background-zoom 600ms;
  animation-fill-mode: both;
}
.quiz-count-down .close-background {
  animation: background-zoom-out 300ms;
  animation-delay: 700ms;
  animation-fill-mode: both;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/quiz-count-down/quiz-count-down.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EACA,uBAAA;AACJ;AACI;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;AACR;AAEI;EACI,gBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAAR;AAGI;EACI,kBAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,sCAAA;AADR;AAII;EACI,gBAAA;AAFR;AAKI;EACI,6BAAA;AAHR;AAMI;EACI;IACI,UAAA;IACA,oCAAA;EAJV;EAMM;IACI,UAAA;IACA,oCAAA;EAJV;EAMM;IACI,UAAA;IACA,sCAAA;EAJV;AACF;AAOI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yCAAA;EACA,sBAAA;AALR;AAQI;EACI;IACI,sBAAA;IACA,kBAAA;EANV;EAQM;IACI,mBAAA;IACA,gBAAA;EANV;AACF;AASI;EACI;IACI,mBAAA;IACA,gBAAA;EAPV;EASM;IACI,mBAAA;IACA,kBAAA;EAPV;AACF;AAWI;EACI,gCAAA;EACA,yBAAA;AATR;AAYI;EACI,oCAAA;EACA,sBAAA;EACA,yBAAA;AAVR","sourcesContent":[".quiz-count-down {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    width: 100%;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    z-index: 2;\n    color: var(--motes-white);\n    pointer-events: initial;\n    \n    .get-ready {\n        position: absolute;\n        font-size: 30px;\n        text-align: center;\n        display: block;\n        top: 20vh;\n        width: 100%;\n    }\n\n    .counter {\n        font-size: 150px;\n        display: flex;\n        opacity: 1;\n        width: 100%;\n        position: relative;\n    }\n\n    .count-label {\n        position: absolute;\n        left: 0;\n        width: 100%;\n        text-align: center;\n        opacity: 0;\n        transform: translateY(-50%) scale(0.1);\n    }\n    \n    .last-counter {\n        font-size: 1.2em;\n    }\n\n    .show-counter {\n        animation: counter-zoom 700ms;\n    }\n\n    @keyframes counter-zoom {\n        30% {\n            opacity: 1;\n            transform: translateY(-50%) scale(1);\n        }\n        80% {\n            opacity: 1;\n            transform: translateY(-50%) scale(1);\n        }\n        100% {\n            opacity: 0;\n            transform: translateY(-50%) scale(0.1);\n        }\n    }\n\n    .background {\n        width: 100vw;\n        height: 100vw;\n        min-width: 100vh;\n        min-height: 100vh;\n        border-radius: 50%;\n        overflow: hidden;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: rgba(32, 32, 32, 0.801);\n        transform: scale(0.01);\n    }\n    \n    @keyframes background-zoom {\n        0% {\n            transform: scale(0.01);\n            border-radius: 50%;\n        }\n        100% {\n            transform: scale(1);\n            border-radius: 0;\n        }\n    }\n\n    @keyframes background-zoom-out {\n        0% {\n            transform: scale(1);\n            border-radius: 0;\n        }\n        100% {\n            transform: scale(0);\n            border-radius: 50%;\n        }\n        \n    }\n\n    .open-background {\n        animation: background-zoom 600ms;\n        animation-fill-mode: both;\n    }\n\n    .close-background {\n        animation: background-zoom-out 300ms;\n        animation-delay: 700ms;\n        animation-fill-mode: both;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
